(function(window, undefined) {
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.authentication', ['ui.router', 'ec.util']);
  })();
  (function(angular) {
    'use strict';
    angular
      .module('ec.authentication')
      .constant('USER_PERMISSIONS', {
        USER: {
          READ: 'USER_READ',
          UPDATE: 'USER_UPDATE',
          CREATE: 'USER_CREATE',
          DELETE: 'USER_DELETE',
        },
        REVIEW: {
          READ: 'REVIEW_READ',
          READ_SUBMITTED_ONLY: 'REVIEW_READ_SUBMITTED_ONLY',
          UPDATE: 'REVIEW_UPDATE',
          UPDATE_SUBMITTED_ONLY: 'REVIEW_UPDATE_SUBMITTED_ONLY',
        },
        REDEMPTION: {
          READ: 'REDEMPTION_READ',
          UPDATE: 'REDEMPTION_UPDATE',
          UPDATE_REQUESTED_ONLY: 'REDEMPTION_UPDATE_REQUESTED_ONLY',
        },
        MERCHANT: {
          READ: 'MERCHANT_READ',
          UPDATE: 'MERCHANT_UPDATE',
          CREATE: 'MERCHANT_CREATE',
        },
        TAG: {
          READ: 'TAG_READ',
          UPDATE: 'TAG_UPDATE',
          CREATE: 'TAG_CREATE',
          DELETE: 'TAG_DELETE',
        },
      })
      .constant('CORE_PRODUCTS', {
        FREE_PLUS: {
          id: 11,
          name: 'FREE_PLUS',
        },
        BASIC: {
          id: 1,
          name: 'BASIC',
        },
        PRO: {
          id: 10,
          name: 'PRO',
        },
        PREMIUM: {
          id: 8,
          name: 'PREMIUM',
        },
      })
      .constant('AUTHENTICATION_EVENTS', {
        LOGIN_SUCCESS: 'authentication.login-success',
        LOGIN_FAILED: 'authentication.login-failed',
        LOGOUT_SUCCESS: 'authentication.logout-success',
        SESSION_TIMEOUT: 'authentication.session-timeout',
        NOT_AUTHENTICATED: 'authentication.not-authenticated',
        NOT_AUTHORIZED: 'authentication.not-authorized',
      })
      .constant('SWITCH_TO_COOKIE_KEY', 'SWITCH_TO_BC');
  })(angular);
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.authentication').directive('ecAccess', ecAccess);
    /** @ngInject */
    function ecAccess(sessionService) {
      var directive = {
        restrict: 'EA',
        link: link,
      };
      return directive;
      function link(scope, element, attrs) {
        var permissions = scope.$eval(attrs.permissions);
        var roles = scope.$eval(attrs.roles);
        if (permissions && permissions !== '' && !sessionService.hasPermission(permissions)) {
          element.addClass('hidden');
        }

        if (roles && roles !== '' && !sessionService.hasRole(roles)) {
          element.addClass('hidden');
        }
      }
    }
    ecAccess.$inject = ['sessionService'];
  })();
  /**
   * author andre.pitombeira
   */
  ('use strict');
  angular.module('ec.authentication').factory('AuthenticationInterceptor', [
    '$injector',
    '$q',
    'localStorageService',
    'HTTP_CODE',
    function AuthenticationInterceptor($injector, $q, localStorageService, HTTP_CODE) {
      var service = {},
        $state;
      service.request = function(config) {
        config.headers = config.headers || {};
        if (localStorageService.getValue('token')) {
          config.headers['X-Quandoo-User-Session'] = '' + localStorageService.getValue('token');
        }
        return config;
      };
      service.responseError = function(rejection) {
        if (rejection && (rejection.status === HTTP_CODE.STATUS.UNAUTHORIZED || rejection.status === HTTP_CODE.STATUS.FORBIDDEN || rejection.status < 0)) {
          $injector.get('$state').transitionTo('auth.signin');
          //Use injector to avoid circular dependency
          rejection.data = {
            status: 401,
            descr: 'unauthorized',
          };
        }
        return $q.reject(rejection);
      };
      service.response = function(response) {
        if (response && response.status === HTTP_CODE.STATUS.UNAUTHORIZED) {
          $injector.get('$state').transitionTo('auth.signin');
          //Use injector to avoid circular dependency
          return $q.reject(response);
        } else {
          return $q.when(response);
        }
      };
      return service;
    },
  ]);
  /**
   * author andre.pitombeira
   */
  (function() {
    'use strict';
    angular.module('ec.authentication').factory('AuthenticationService', AuthenticationService);
    /** @ngInject */
    function AuthenticationService($rootScope, $http, $q, $cookies, sessionService, AUTHENTICATION, SWITCH_TO_COOKIE_KEY) {
      var service;
      service = {
        isAuthenticated: false,
        signin: signin,
        signout: signout,
        checkAuthentication: checkAuthentication,
      };
      return service;
      function signin(user) {
        return $http.post(AUTHENTICATION.SESSIONS, user);
      }
      function signout() {
        $cookies.remove(SWITCH_TO_COOKIE_KEY);
        $rootScope.$broadcast('sign.out');
        if (sessionService.getSession().token !== '') {
          return $http.delete(AUTHENTICATION.SESSIONS);
        } else {
          return $q.when();
        }
      }
      function checkAuthentication() {
        return $http.get(AUTHENTICATION.PING).then(
          function() {
            service.isAuthenticated = true;
          },
          function() {
            service.isAuthenticated = false;
          },
        );
      }
    }
    AuthenticationService.$inject = ['$rootScope', '$http', '$q', '$cookies', 'sessionService', 'AUTHENTICATION', 'SWITCH_TO_COOKIE_KEY'];
  })();
  /**
   * author andre.pitombeira
   */
  (function(angular) {
    'use strict';
    angular.module('ec.authentication').factory('sessionService', sessionService);
    /** @ngInject */
    function sessionService(localStorageService, CORE_PRODUCTS) {
      var userPermissions = [],
        currentSession,
        service;
      service = {
        userPermissions: userPermissions,
        currentSession: currentSession,
        createSession: createSession,
        destroySession: destroySession,
        getSession: getSession,
        hasPermission: hasPermission,
        hasRole: hasRole,
      };
      activate();
      return service;
      function activate() {
        setCurrentSession();
      }
      function createSession(data) {
        localStorageService.storeValue('businessName', data.hasOwnProperty('businessName') ? data.businessName : '');
        localStorageService.storeValue('merchantId', data.hasOwnProperty('merchantId') ? data.merchantId : '');
        localStorageService.storeValue('chainId', data.hasOwnProperty('chainId') ? data.chainId : '');
        localStorageService.storeValue('employeeId', data.hasOwnProperty('employeeId') ? data.employeeId : '');
        localStorageService.storeValue('productTypeIds', data.hasOwnProperty('productTypeIds') ? data.productTypeIds : '');
        localStorageService.storeValue('locale', data.hasOwnProperty('locale') ? data.locale : '');
        localStorageService.storeValue('token', data.token);
        localStorageService.storeValue('login', data.login);
        localStorageService.storeValue('permissions', data.permissions);
        localStorageService.storeValue('roles', data.roles);
        setCurrentSession();
      }
      function destroySession() {
        localStorageService.storeValue('token', '');
        localStorageService.storeValue('login', '');
        localStorageService.storeValue('permissions', '');
        localStorageService.storeValue('businessName', '');
        localStorageService.storeValue('merchantId', '');
        localStorageService.storeValue('chainId', '');
        localStorageService.storeValue('employeeId', '');
        localStorageService.storeValue('productTypeIds', '');
        localStorageService.storeValue('locale', '');
        localStorageService.storeValue('roles', '');
      }
      function getSession() {
        var session = {};
        session.token = localStorageService.getValue('token');
        session.login = localStorageService.getValue('login');
        session.permissions = localStorageService.getValue('permissions') ? localStorageService.getValue('permissions').split(',') : [];
        session.roles = localStorageService.getValue('roles') ? localStorageService.getValue('roles').split(',') : [];
        session.businessName = localStorageService.getValue('businessName');
        session.merchantId = localStorageService.getValue('merchantId');
        session.chainId = parseInt(localStorageService.getValue('chainId'), 10);
        session.employeeId = localStorageService.getValue('employeeId');
        session.productTypeIds = getProductTypeIds();
        session.locale = localStorageService.getValue('locale');
        return session;
      }
      function getProductTypeIds() {
        var idsOnLocalStorage = localStorageService.getValue('productTypeIds');
        return idsOnLocalStorage
          ? idsOnLocalStorage.split(',').map(function(id) {
              return parseInt(id, 10);
            })
          : [];
      }
      function setCurrentSession() {
        service.currentSession = getSession();
        service.userPermissions = service.currentSession.permissions || [];
        service.userRoles = service.currentSession.roles || [];
        service.coreProduct = setProductOnSession();
      }
      function hasPermission(permissions) {
        return service.userPermissions.some(function(userPermission) {
          return permissions.indexOf(userPermission) !== -1;
        });
      }
      function hasRole(roleNames) {
        return service.userRoles.some(function(role) {
          return roleNames.indexOf(role) !== -1;
        });
      }
      function setProductOnSession() {
        var productIds = service.currentSession.productTypeIds,
          product = null;
        if (productIds && productIds.length) {
          for (var key in CORE_PRODUCTS) {
            if (CORE_PRODUCTS.hasOwnProperty(key)) {
              if (productIds.indexOf(CORE_PRODUCTS[key].id) > -1) {
                product = CORE_PRODUCTS[key].name;
                break;
              }
            }
          }
        }
        return product;
      }
    }
    sessionService.$inject = ['localStorageService', 'CORE_PRODUCTS'];
  })(angular);
})(window, undefined);



// WEBPACK FOOTER //
// ./src/app/vendor/ec-fe-bo-template/dist/authentication/authentication.max.js